import { render } from "./creation.vue?vue&type=template&id=7a052616&ts=true"
import script from "./creation.vue?vue&type=script&lang=ts"
export * from "./creation.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__